import { useMutation } from '@tanstack/react-query';

import config from 'config';

import * as Api from '../api';
import * as Mappers from '../mappers';
import * as Types from '../types';
import { loadAccessContext } from '../access';
import { useAuthContext } from '../context';

/** Applies the refreshed profile so `profileComplete` flips client-side and the guard releases. */
export const useCompleteOnboarding = () => {
  const { methods } = useAuthContext();

  return useMutation({
    mutationFn: async (values: Types.IApi.CompleteOnboarding.Request) => {
      const { data } = await Api.CompleteOnboarding(values);
      return data;
    },
    onSuccess: (data) => {
      methods.setUser(Mappers.User(data.user));

      const orgs = (data.organizations || []).map((o: any) => ({
        ...Mappers.Organization(o),
        role: o.role,
      }));
      methods.setOrganizations(orgs);

      methods.setOrganization(data.organization ? Mappers.Organization(data.organization) : null);
      methods.setRole(data.role);

      // Persist active org FIRST (sets the X-Organization-Id header), then fetch
      // permissions + entitlements from their dedicated endpoints.
      if (data.organization) {
        localStorage.setItem(config.api.active_org_key, data.organization.id);
        void loadAccessContext(methods);
      } else {
        methods.setPermissions([]);
        methods.setEntitlements(null);
      }
    },
  });
};
